import { SearchInput, SelectInput, required } from "react-admin";

import {
  CLIENT_SEARCH_SOURCE,
  FILTER_LIMIT_OPTIONS,
} from "@/constants/filters";

import { TICKET_TYPES_OPTIONS } from "./constants";

export const ticketsListFilters = [
  <SearchInput
    key="search"
    placeholder="Search Ticket by Page"
    source={CLIENT_SEARCH_SOURCE}
    alwaysOn
  />,
  <SelectInput
    key="type"
    label="Type"
    source="type"
    choices={TICKET_TYPES_OPTIONS}
    alwaysOn
  />,
  <SelectInput
    key="limit"
    label="Limit"
    source="limit"
    choices={FILTER_LIMIT_OPTIONS}
    validate={required()}
    alwaysOn
  />,
];
